<template>
  <div class="pricing-plan">
    <Header/>
		<LoggedInUserHeader/>
    <!-- <Header/> -->
    <h1 class="title">Choose Your Plan</h1>
    <div class="pricing-plan-wrapper">
      <div class="free-trial">
        <span class="trial-title">FREE TRIAL</span>
        <div class="free-trial-main">
          <h6>5 free searches</h6>
          <h4>&dollar;0.00</h4>
          <p>Includes Access to all Active Markets and Filter Functions</p>
          <p>No credit card required.</p>
          <router-link v-if='user' to="/search" class="orange-btn">
            <a>Continue with Free Trial</a>
          </router-link>
          <router-link v-else to="/login" class="orange-btn">
            <a>Continue with Free Trial</a>
          </router-link>
        </div>
      </div>
      <PricingPlanMain/>
      <!-- <div class="a-la-carte">
        <span>A LA CARTE</span>
        <div class="carte-main">
          <h6>Coming Soon</h6>
          <h4>Q4 2021</h4>
          <p>Select the Regions specific to your needs.</p>
          <ul>
            <li>Southeast Asia</li>
            <li>South Asia (coming soon 2021)</li>
            <li>Greater China (coming soon 2021)</li>
            <li>Asia Pacific (coming soon 2021)</li>
            <li>N. America (coming soon 2021)</li>
          </ul>
        </div>
      </div> -->
    </div>
    <p class="login-link" v-if='currentUser'>
      Already a member?
      <router-link to="/login">
        <a>Log In</a>
      </router-link>
    </p>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/layout/header.vue';
import LoggedInUserHeader from '@/components/user/dashboard/core/TopBar.vue';
import PricingPlanMain from '@/components/global/pricing-plan.vue';
import * as isUserLoggedIn from '@/store/isUserLoggedIn';
import Footer from '@/components/layout/footer.vue';

export default {
  name: "pricing-plan",
  components: {
    Header,
    PricingPlanMain,
    LoggedInUserHeader,
    Footer
  },

  data() {
			return {
					user: isUserLoggedIn.isUserLoggedIn()
			}
	},
};
</script>

<style lang="scss">
  .pricing-plan {
    background: #f9f9f9;
    min-height: 100vh;

    h1.title {
      text-align: center;
      padding: 35px 0 50px 0;
    }

    .pricing-plan-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 80%;
      margin: auto;

      .free-trial {
        width: 25%;
        background: #fff;
        box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
        border-radius: 15px;
        padding: 45px 0;

        span {
          padding: 6px 40px;
          background: #f9f9f9;
          font-size: 18px;
          line-height: 29px;
          font-family: "Gotham-Bold";
          width: 100%;
          display: inline-block;
        }

        .free-trial-main {
          padding: 0 40px;

          h6 {
            font-size: 16px;
            line-height: 26px;
            font-family: "Gotham-Medium";
            margin: 30px 0 0 0;
          }

          h4 {
            font-size: 42px;
            line-height: 33px;
            margin-bottom: 20px;
          }

          p {
            font-size: 14px;
            line-height: 22px;
            color: #676868;

            &:first-of-type {
              margin-bottom: 50px;
            }
          }

          .orange-btn {
            background: #ebebeb;
            color: #333;
            font-family: "Gotham-Book";
          }
        }
      }

      .a-la-carte {
        width: 25%;
        background: #fff;
        box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
        border-radius: 15px;
        padding: 45px 0;
        align-self: stretch;

        span {
          padding: 6px 40px;
          background: #FCAF05;
          font-size: 18px;
          line-height: 29px;
          font-family: "Gotham-Bold";
          width: 100%;
          display: inline-block;
          color: #fff;
        }

        .carte-main {
          padding: 0 40px;

          h6 {
            margin: 30px 0 10px 0;
          }

          h4 {
            font-size: 42px;
            line-height: 33px;
            margin-bottom: 20px;
          }

          p {
            font-size: 16px;
            line-height: 22px;
            color: #676868;
          }

          ul {
            font-size: 14px;
            line-height: 22px;
            color: #676868;
            padding-inline-start: 20px;
          }
        }
      }

      .free-wrapper {
        width: 95%;

        .featured {
          p, 
          span, 
          h5, 
          ul, 
          del, 
          .per-year {
            padding: 0 40px;
          }

          a {
            margin: 0 40px;
          }

          ul {
            padding-inline-start: 60px;
          }

          .per-year {
            p {
              padding: 0;
            }
          }
        }

        .markets {
          padding-left: 40px;
          background: url('~@/assets/images/components/fee-alternate.svg') bottom right no-repeat;

          .market-items {
            .market-item {
              margin-right: 1.5rem;

              .coming-br {
                display: inline;
              }
            }
          }
        }
      }
    }

    p.login-link {
      text-align: center;
      margin-top: 40px;

      a {
        color: #FCAF05;
        font-family: "Gotham-Medium";
      }
    }
  }
</style>